import styled from "@emotion/styled";
import { Button, Dialog } from "@mui/material";
import { ArticleItem } from "./News.styles";
import { styled as MuiStyled } from "@mui/material/styles";
import { css } from "@emotion/react";

export const LayoutWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

export const H2 = styled.h2`
  font-weight: 800;
  font-size: clamp(28px, 3vw, 52px);
  line-height: 90px;
  margin-bottom: 20px;
  margin-top: 0;
  text-transform: uppercase;
  text-align: ${({ textAlign }) => textAlign || "center"};
  color: ${({ color, theme }) =>
    color === "secondary" ? "#FFF" : theme.palette.primary.main};
`;

export const ShortDescription = styled.p`
  font-weight: 500;
  font-size: 15px;
  line-height: 26px;
  color: #000000;
  ${props =>
    !!props.dir
      ? css`
          direction: ${props => props.dir};
        `
      : ""}
`;

export const SubTitleParagraph = styled.p`
  font-weight: 400;
  font-size: clamp(16px, 2vw, 18px);
  line-height: 34px;
  text-align: ${({ textAlign }) => textAlign || "center"};
  color: ${({ color, theme }) => color || theme.palette.gray};
`;

export const SecondSubTitleParagraph = styled.p`
  font-weight: 500;
  font-size: clamp(18px, 2vw, 24px);
  text-transform: uppercase;
  color: #ffffff;
`;

export const H4 = styled.h4`
  font-weight: 500;
  font-size: clamp(22px, 2vw, 28px);
  color: #ffffff;
`;

export const PrimaryButton = styled(Button)(({ theme }) => ({
  background: "#ed1e24",
  borderRadius: 50,
  fontWeight: 500,
  fontSize: "clamp(15px, 1vw, 18px)",
  lineHeight: "18px",
  textTransform: "capitalize",
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  color: "#ffffff",
  padding: 0,
  "&:hover": {
    backgroundColor: "#f33339",
    borderColor: "#ed1e24",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#f33339",
    borderColor: "#ed1e24",
  },
  " a": {
    color: "#ffffff",
    display: "inline-block",
    width: "100%",
    height: "100%",
    padding: "17px 30px",
  },
  [theme.breakpoints.down("lg")]: {
    " a": {
      padding: "9px 20px",
    },
  },
}));

export const SecondaryButton = styled(Button)(({ theme }) => ({
  padding: "9px 47px",
  background: "#17479E",
  borderRadius: 50,
  height: 42,
  fontWeight: 400,
  fontSize: 14,
  lineHeight: "18px",
  textTransform: "capitalize",
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  color: "#ffffff",
  "&:hover": {
    boxShadow: "none",
    backgroundColor: "#1955ba",
    borderColor: "#17479E",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#1955ba",
    borderColor: "#17479E",
  },
}));

export const RegularButton = styled(Button)(({ theme }) => ({
  padding: "9px 21px",
  background: "#F2F2F3",
  borderRadius: 50,
  height: 42,
  fontWeight: 400,
  fontSize: 14,
  lineHeight: "18px",
  textTransform: "capitalize",
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  color: "#000",
  "&:hover": {
    backgroundColor: "#cecece",
    borderColor: "#F2F2F3",
  },
  "&:active": {
    backgroundColor: "#cecece",
    borderColor: "#F2F2F3",
  },
}));

export const DetailsPage = styled.main(
  {
    backgroundColor: " #f9f9f9",
  },
  ({ theme }) => ({
    [ArticleItem]: {
      marginBottom: 0,
      padding: "20px 0",
      [theme.breakpoints.up("md")]: {
        ".date": {
          display: "none",
        },
      },
    },
  }),
);

export const MainArticle = styled.article`
  background: #ffffff;
  box-shadow: 0 10px 15px -4px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  margin-bottom: 110px;
  padding: 80px 0;
  margin-top: 60px;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      boxShadow: "unset",
      borderRadius: 0,
      margin: 0,
      paddingBottom: "60px",
      paddingTop: "40px",
    },
  })}
`;

export const ContainerArticle = styled.div`
  max-width: 912px;
  margin: 0 auto;
  padding: 0 16px;
  .imageWrapper {
    position: relative;
    border-radius: 15px;
    overflow: hidden;
    margin: 30px 0;
  }

  figure.image-style-side {
    text-align: center;
    font-style: italic;
    font-size: smaller;
    text-indent: 0;
  }
  figure.image-style-side:nth-of-type(odd) {
    float: right;
  }
  figure.image-style-side:nth-of-type(even) {
    float: left;
  }

  figure.table {
    float: unset !important;
    width: auto !important;
    table {
      margin: 0 auto;
    }
  }

  p {
    line-height: 28px;
    margin-bottom: 15px;
  }

  .MuiDivider-root {
    border: 1px solid #e6e6e7;
  }

  .attachment {
    p {
      margin-bottom: 10px;
    }
    a {
      display: flex;
      color: #17479e;
      text-decoration: underline;
      margin-bottom: 10px;
    }
  }

  .content {
    span {
      font-family: inherit !important;
    }
  }

  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      padding: "0 0 20px",
      ".imageWrapper": {
        borderRadius: 0,
        margin: "20px 0",
      },

      ".content": {
        padding: "0px 16px",
      },
    },
  })}
`;

export const ArticleHeader = styled.header`
  margin-bottom: 60px;
  .title {
    font-weight: 800;
    font-size: clamp(22px, 2.3vw, 26px);
    line-height: 45px;
    color: #000000;
    margin-bottom: 25px;
  }
  .date {
    span {
      font-size: 14px;
    }
    svg {
      width: 17px;
    }
  }

  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      marginBottom: "20px",
      padding: "0 16px",
      ".title": {
        lineHeight: "38px",
      },
    },
  })}
`;

export const GalleryWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(283px, 1fr));
  grid-gap: 15px;
  margin-top: 80px;
  .imageThumb {
    border-radius: 15px;
    overflow: hidden;
    cursor: pointer;
  }
  .videoThumb {
    border-radius: 15px;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    video {
      max-width: 100%;
      max-height: 100%;
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
    .playIcon {
      position: absolute;
      z-index: 5;
      width: 70px;
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url(/images/play-button.svg);
      border-radius: 50%;
    }
  }
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      padding: "0 16px",
      gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    },
  })}
`;

export const PageHeaderWrapperDiv = styled.div`
  max-height: 410px;
  padding-bottom: 60px;
  padding-top: 160px;
  background-image: linear-gradient(
      180deg,
      rgba(0, 79, 198, 0.85) 0%,
      rgba(0, 55, 138, 0.85) 60.1%
    ),
    url(${props => props.bgImage || ""});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  overflow: hidden;
  position: relative;
  ${({ theme }) => ({
    [theme.breakpoints.down(1058)]: {
      paddingTop: 190,
      paddingBottom: 40,
    },
    [theme.breakpoints.down("md")]: {
      paddingTop: 45,
    },
  })}
`;

export const PageHeaderWrapper = styled.header`
  max-height: 410px;
  padding-bottom: 60px;
  padding-top: 290px;
  color: #fff;
  background-image: linear-gradient(
      180deg,
      rgba(0, 79, 198, 0.85) 0%,
      rgba(0, 55, 138, 0.85) 60.1%
    ),
    url(${props => props.bgImage || ""});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  overflow: hidden;
  position: relative;
  .title {
    display: inline-block;
    border: none;
    border-left: 2px solid #fff;
    padding: 0 30px;
    font-weight: 700;
    font-size: clamp(26px, 3vw, 36px);
    text-transform: capitalize;
  }
  ${({ theme }) => ({
    [theme.breakpoints.down(1058)]: {
      paddingTop: 190,
      paddingBottom: 40,
      textAlign: "center",
      ".title": {
        borderLeft: "none",
      },
    },
    [theme.breakpoints.down("md")]: {
      paddingTop: 130,
    },
  })}
`;

export const StandardImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  max-width: ${({ width }) => (width ? width + "px" : "100%")};
  max-height: ${({ height }) => (height ? height + "px" : "100%")};
`;

export const DataLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 100px 0;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  z-index: 2;
  width: 105%;
  height: 105%;
  top: -10px;
  left: -10px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(1px);
  border-radius: 20px;
`;

export const UlStyleTypeTick = styled.ul`
  margin-left: 27px;
  list-style-image: url("/images/icons/check-icon.svg");
`;

export const UlStyleTypeCircle = styled.ul`
  margin-left: 27px;
  li::before {
    content: " ";
    border: 5px solid #17479e;
    border-radius: 50%;
    height: 0;
    width: 0;
    margin-top: 10px;
    margin-left: -25px;
    position: absolute;
  }
`;

export const Li = styled.li`
  font-weight: 400;
  font-size: 16px;
  line-height: 34px;
  color: #808285;
`;

export const RegularParagraph = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 34px;
  color: #808285;
`;

export const RegularTitle = styled.h2`
  font-weight: 800;
  font-size: clamp(26px, 3vw, 34px);
  line-height: 61px;
  color: #000000;
`;

export const H2BorderBlue = styled.h2`
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 40px;
  color: #000000;
  padding: 8px 30px;
  border-left: 4px solid #17479e;
  margin-bottom: 28px;
  text-align: left;
`;

export const RegularSubTitle = styled.h3`
  font-weight: 700;
  font-size: 22px;
  line-height: 40px;
  color: #000000;
`;

export const MainPage = styled.main`
  margin: 80px 0;
  .borderRight {
    border-right: 2px solid #f2f2f3;
  }
  .completeOrder {
    padding: 15px 30px;
  }
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      margin: "60px 0 80px 0",
      ".borderRight": { borderRight: "none" },
    },
  })}
`;

export const ResultBox = styled.div`
  border: 1px solid #f2f2f3;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  transition: all 250ms ease-in-out;
  &:hover {
    box-shadow: 0 0 10px 0 #8d8e91;
  }
  .boxes {
    .imageWrapper {
      position: relative;
      min-width: 100px;
      height: 110px;
      overflow: hidden;
      background-color: antiquewhite;
    }
    .content {
      padding-left: 24px;
      .title {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.02em;
        color: ${({ theme }) => theme.palette.primary.main};
        margin-bottom: 10px;
        margin-top: 10px;
        ${props =>
          props.locale === "fa"
            ? css`
                direction: rtl;
                text-align: left;
              `
            : ""}
      }
      .text {
        font-weight: 400;
        font-size: 14px;
        line-height: 28px;
        color: #000000;
        margin-bottom: 10px;
        margin-right: 10px;
      }
    }
  }
`;

//***************************************************//
//********************MuiStyled**********************//
export const MuiDialog = MuiStyled(Dialog)(({ theme, locale }) => ({
  ".MuiDialog-paper": {
    width: "100vw",
    height: "100vh",
    maxWidth: "100%",
    maxHeight: "100%",
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  ".MuiDialogTitle-root": {
    fontWeight: "700",
    fontSize: "clamp(26px,3vw,36px)",
    textTransform: "capitalize",
    color: "#17479e",
  },
  ".close": {
    position: "absolute",
    right: "100px",
    top: "50px",
    width: 50,
    height: 50,
    svg: {
      path: {
        fill: "#17479e",
      },
    },
  },
}));
